import cls from "classnames";
import { useQuery, useMutation } from "@tanstack/react-query";
import { useSetAtom } from "jotai";
import { vipModalShowAtom } from "@/atom/user";
import useWork from "@/hooks/useWork";
import { VipItem, VipInfo, fetchVipInfo, creatOrder } from "@/services/api";
import { useNavigate } from "react-router-dom";
import { message } from "../Toast";
import s from "./index.module.scss";
import { fetchHomeInit } from "@/services/api";
import { userInfoAtom } from "@/atom/user";
import { useAtomValue } from "jotai";

const ModalVip = () => {
  const navigate = useNavigate();
  const setVipModalShow = useSetAtom(vipModalShowAtom);
  const userInfo = useAtomValue(userInfoAtom);
  const { add } = useWork();

  const handleClose = () => {
    setVipModalShow(false);
  };
  
  const handleLoopAi = async () => {
    const res = await fetchHomeInit(userInfo?.userId);
    if (res.code === 3102) {
      navigate("/enter");
    } else if (res.code !== 0) {
      console.log("立即开始 error:", res);
    } else {
      const parsedUrl = new URL(res?.data?.url);
      const id = parsedUrl.searchParams.get("workId");
      navigate(`/work?currentWorkId=${id}`);
    }
  };

  const handleItem = async (item: VipItem) => {
    if (item.activated) {
      // add();
      setVipModalShow(false);

      handleLoopAi();
    } else {
      mutationCreatOrder.mutate({
        vipType: item.vipType,
      });
    }
  };

  const mutationCreatOrder = useMutation({
    mutationFn: creatOrder,
    onSuccess: (data) => {
      const { orderId, orderRemaining, payState } = data?.data || {};
      if (payState === 2) {
        navigate("/paySuccess");
      } else {
        if (orderId) {
          navigate(`/pay?orderId=${orderId}&remain=${orderRemaining}`);
          setVipModalShow(false);
        }
      }
    },
    onError: () => {
      message.info("创建订单失败，请重试", 3000);
    },
  });

  const { data } = useQuery<VipInfo>({
    queryKey: ["fetchVipInfo"],
    queryFn: async () => {
      try {
        const data = await fetchVipInfo();
        return data.data;
      } catch (error) {
        throw new Error("fetchVipInfo failed");
      }
    },
  });

  return (
    <section className={s.modalContain}>
      <div className={s.modal}>
        <a className={s.close} onClick={handleClose} />
        <ul className={s.list}>
          {data?.vips?.map((item) => {
            return (
              <li
                key={item.vipType}
                className={cls({ [s.activated]: item.activated })}
              >
                <h2>
                  {item.vipType.replace("p", "P")}{" "}
                  <span>￥{item.realAmount}</span>
                  <span style={{ fontSize: 15, alignSelf: "center",marginLeft:-1 }}>
                    {item.vipType === "++plus" ? "/ 年" : "/ 月"}
                  </span>
                </h2>
                <div className={s.secTitle}>
                  有效期：<strong>{item.validityRange}</strong>
                  {/* <strong>¥{parseFloat(item.realAmount.toFixed(2))}</strong> /
                  每月 */}
                </div>
                <button
                  className={cls({
                    [s.button]: true,
                    [s.diabled]: item.activated,
                  })}
                  onClick={() => handleItem(item)}
                >
                  {item.activated ? "立即开始" : `升级至${item.vipType}`}
                </button>
                <ul className={s.desc}>
                  {item.rights.map((right) => (
                    <li>{right}</li>
                  ))}
                </ul>
              </li>
            );
          })}
        </ul>
      </div>
    </section>
  );
};

export default ModalVip;
